<div class="modal-header b px-5">
  <h6 class="modal-title font-weight-500 text-defualt"> Email Template</h6>
  <span type="button" class="close font-weight-normal f-16 ms-auto" data-bs-dismiss="modal" aria-bs-label="Close"
    (click)="dismiss()">
   <i class="fas fa-times f-14 text-black"></i>
</span>
</div>
<div class="modal-body pt-0 px-5">
  <div class="form-group mb-0">
    <form [formGroup]="editecompanydetail">
      <div class="row mb-3">
        <div class="col  pointer">
          <label for="templatename" class="f-12">Template name <span class="text-danger">*</span>
          </label>
          <div class="position-relative">
            <input data-testid="auto-app-edit-email-template-input-1" type="text" placeholder="Enter template name" class="wc-form-control nobg"
              formControlName="actionname">
            <p *ngIf="editecompanydetail.get('actionname').errors?.required && (editecompanydetail['controls'].actionname.dirty || editecompanydetail['controls'].actionname.touched)"
              [ngClass]="['text-left','my-1','text-danger']">Template Name is required</p>
              <p *ngIf="editecompanydetail['controls'].actionname .hasError('pattern')" class="text-danger f-12 pt-1">
                HTML tags are not allowed</p>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-8 pointer">
          <label for="subject" class="f-12">Email Subject <span class="text-danger">*</span>
          </label>
          <div class="position-relative">
            <input data-testid="auto-app-edit-email-template-input-2" type="text" placeholder="Enter email subject" class="wc-form-control nobg" #subject
              (input)="getCursorPosition('subject');" (click)="getCursorPosition('subject');" formControlName="subject">
            <p *ngIf="editecompanydetail.get('subject').errors?.required && (editecompanydetail['controls'].subject.dirty || editecompanydetail['controls'].subject.touched)"
              [ngClass]="['text-left','my-1','text-danger']">Template Subject is required</p>
              <p *ngIf="editecompanydetail['controls'].subject.hasError('pattern')" class="text-danger f-12 pt-1">
                HTML tags are not allowed</p>
          </div>
        </div>
        <div class="col-md-4">
          <label for="placeholder" class="f-12">Placeholders
          </label>
          <div class="position-relative">
            <span class="selectdrop-down position-absolute tr0 mt-2 mr-2 gray-text">
              <i class="fas fa-chevron-down"></i>
            </span>
            <select data-testid="auto-app-edit-email-template-select-1" class="defaultText" [disabled]="!placeid" class="wc-form-control nobg position-relative" (change)="selectplaceholder($event)">
              <option class="defaultText" value=null [selected]="!placeid">Select placeholder</option>
              <option class="optionText" *ngFor="let x of placeholderlist" [value]="x.value">{{x.value}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label for="emaiteplate" class="f-12">Email Template body<span class="text-danger">*</span>
          </label>
          <div>
            <!-- <angular-editor id="templatebody" [config]="editorConfig" name="templatebody" formControlName="template"
              (input)="getCursorPosition('body');" (click)="getCursorPosition('body');">
            </angular-editor> -->
            <p-editor formControlName="template" [style]="{'height':'250px'}" id="templatebody" (onTextChange)="getCursorPosition('body');" (click)="getCursorPosition('body');">
              <ng-template pTemplate="header">
            <span class="ql-formats">
              <select data-testid="auto-app-edit-email-template-select-2" class="ql-size">
                <option value="small">Tiny</option>
                <option selected></option>
                <option value="large">Subheading</option>
                <option value="huge">Heading</option>
              </select>
            </span>
            <span class="ql-formats">
              <button data-testid="auto-app-edit-email-template-button-1" type="button" class="ql-bold" aria-label="Bold"></button>
              <button data-testid="auto-app-edit-email-template-button-2" type="button" class="ql-italic" aria-label="Italic"></button>
              <button data-testid="auto-app-edit-email-template-button-3" type="button" class="ql-underline" aria-label="Underline"></button>
              <button data-testid="auto-app-edit-email-template-button-4" type="button" class="ql-list" aria-label="Unordered list" value="bullet"></button>
              <button data-testid="auto-app-edit-email-template-button-5" type="button" class="ql-link" aria-label="Insert link"></button>
              <button data-testid="auto-app-edit-email-template-button-6" type="button" class="ql-clean" aria-label="Remove Styles"></button>
              <span class="ql-formats">
                <select data-testid="auto-app-edit-email-template-select-3" title="Text Alignment" class="ql-align" >
                  <option selected>Gauche</option>
                  <option value="center" label="Center"></option>
                  <option value="right" label="Right"></option>
                  <option value="justify" label="Justify"></option>
                </select>
              </span>
              <button data-testid="auto-app-edit-email-template-button-7" type="button" class="ql-image"></button>
          </span>
          </ng-template>
      </p-editor>
            <p *ngIf="editecompanydetail.get('template').errors?.required && (editecompanydetail['controls'].template.dirty || editecompanydetail['controls'].template.touched)"
              [ngClass]="['text-left','my-1','text-danger']">Template Body is required</p>
              <p *ngIf="editecompanydetail['controls'].template.hasError('scriptTagError')" [ngClass]="['text-left','my-1','text-danger']">
                Script tags are not allowed</p>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer b pb-5">
  <button data-testid="auto-app-edit-email-template-button-8" type="button" class="btn-trms-small m-auto" data-dismiss="modal"
    (click)="updatetemp()">Save</button>
</div>

<ng-template #error class="modal reloginmodal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-edit-email-template-button-9" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/error-vector.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">ERROR</p>
          <p class="text-center">{{errorMessage}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-edit-email-template-button-10" class="btn-trms-small m-auto" (click)="modalService.dismissAll()">CLOSE</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #success class="modal reloginmodal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-edit-email-template-button-11" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/success-vector.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">CONGRATULATIONS !!!</p>
          <p class="text-center">{{successMessage}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-edit-email-template-button-12" class="btn-trms-white mx-auto" (click)="modalService.dismissAll()">CANCEL</button>
          <button data-testid="auto-app-edit-email-template-button-13" class="btn-trms-small m-auto" (click)="modalService.dismissAll()">DONE</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
